import { localeLanguageCodes, localeNames } from 'shared-locales';
import { FlagIcon } from 'components/common';

import type { Locales } from 'shared-types';

interface Props {
  style?: React.CSSProperties;
  translations: { [key in Locales]?: string } | null;
}

const AttributeTranslationsInfo = ({ style, translations }: Props) => {
  if (
    !translations ||
    !Object.keys(translations).some((locale) => translations[locale])
  ) {
    return null;
  }

  return (
    <div className="translations" style={style}>
      {Object.keys(translations)
        .filter((locale) => translations[locale])
        .map((locale) => (
          <div
            className="translation"
            key={locale}
            aria-label={`${localeNames[locale]}: ${translations[locale]}`}
            data-tooltip={translations[locale]}
          >
            <FlagIcon lang={localeLanguageCodes[locale]} />
          </div>
        ))}

      <style jsx>{`
        .translations {
          display: inline-flex;
          gap: 10px;
        }
      `}</style>
    </div>
  );
};

export default AttributeTranslationsInfo;
